// extracted by css-extract-rspack-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_iZC","cls2":"ChurnedUserReactivationButton-cls2_TB_ ChurnedUserReactivationButton-cls1_iZC"};